import { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { MedicationSchemeOverview } from '@/modules/questionnaire/components/question-observation/medication/MedicationSchemeOverview'

import type {
  MedicationFileAttachment,
  MedicationSchemeStatus,
  MedicationStatement,
} from '@/modules/app/types/HealthParameter.types'

type MedicationAnswerProps = {
  title: string
  description: string
  medications: MedicationStatement[]
  schemeStatus?: MedicationSchemeStatus
  files?: MedicationFileAttachment[]
}

export const MedicationAnswer = ({ title, description, medications, schemeStatus, files }: MedicationAnswerProps) => {
  const theme = useTheme()

  return (
    <FlexColumn gap={theme.UI.Spacing.Space2}>
      <Span type='BodyMediumBold' color={theme.Colors.Neutrals.Darkest}>
        {`${title && description ? `${title}: ` : title || ''}${description}`}
      </Span>
      <MedicationSchemeOverview medications={medications} schemeStatus={schemeStatus} files={files} />
    </FlexColumn>
  )
}
